import {inject, Injectable} from '@angular/core';
import {BaseApiService} from "./base-api.service";
import {TableSort} from "../interfaces/table/table-sort";

@Injectable({
  providedIn: 'root'
})
export class InvitedUsersService {
  private readonly apiService = inject(BaseApiService);

  async getInvitedUsers(limit: number, offset: number, search: string, sort: TableSort | null) {
    return await this.apiService.post('/invite-user/list', {
      offset: offset,
      limit: limit,
      search: search,
      sort: sort != null ? JSON.stringify(sort) : null,
      show_inactive: true,
      user_id: "0"
    });
  }

  async createInvitedUser(body: any) {
    return await this.apiService.post('/invite-user', body);
  }

  async createUser(id: any, body: any) {
    return await this.apiService.post(`/invite-user/${id}/create-user`, body);
  }

  async getInvitedUser(token: string) {
    return await this.apiService.post('/invite-user/get-by-token', {
      token: token
    });
  }
}
